import React, { useState, useEffect } from "react";
import HeatmapTable, { hexToStatus } from "../heatmap/HeatmapTable";
import Loading from "../../../../common-components/Loading";
import { getL2HeatmapYTDAPI } from "../../../../api/reports-api";

const COLS = [
  { key:"ytdRevActuals", label:"YTD Contract\nRevenue Actuals", w:155, isCurrency:true  },
  { key:"ytdRevBudget",  label:"YTD Contract\nRevenue Budget",  w:155, isCurrency:true  },
  { key:"ytdGm",         label:"YTD GM",                        w:110, isCurrency:true  },
  { key:"ytdGmBudget",   label:"YTD GM Budget",                 w:115, isCurrency:true  },
  { key:"vacantFTEs",    label:"Vacant FTEs",                   w:90,  isCurrency:false },
];

function mapRow(r) {
  return {
    id: r.clin, projectName: r.projectName, pm: r.programManager,
    ytdRevActuals: r.contractRevenue, ytdRevBudget: r.contractRevenueBudget,
    ytdGm: r.grossMargin, ytdGmBudget: r.grossMarginBudget,
    vacantFTEs: r.vacantFte,
    financial: hexToStatus(r.financial), performer: hexToStatus(r.perform), funding: hexToStatus(r.funding),
    staffing: hexToStatus(r.staffing), culture: hexToStatus(r.culture), customer: hexToStatus(r.customer), doge: hexToStatus(r.doge),
  };
}

function mapTotal(t) {
  return {
    ytdRevActuals: t.contractRevenue, ytdRevBudget: t.contractRevenueBudget,
    ytdGm: t.grossMargin, ytdGmBudget: t.grossMarginBudget, vacantFTEs: t.vacantFte,
    financial: null, performer: null, funding: null, staffing: null,
    culture: null, customer: null, doge: null,
  };
}

export default function YTDl2Heatmap({ filters, onMeta }) {
  const programManager = filters?.programManager || [];
  const [loading,  setLoading]  = useState(true);
  const [rows,     setRows]     = useState([]);
  const [totalRow, setTotalRow] = useState(null);
  const [title,    setTitle]    = useState("YTD L2 Report");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getL2HeatmapYTDAPI({ year: filters?.year, programManager })
      .then((res) => {
        if (cancelled) return;
        const d = res?.data;
        if (d) {
          setRows((d.rows || []).map(mapRow));
          setTotalRow(mapTotal(d.totals || {}));
          setTitle(`YTD L2 Report — FY${d.fiscalYear}`);
          onMeta?.({
            actualThroughMonth: d.actualThroughMonth,
            fiscalYear: d.fiscalYear,
          });
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [JSON.stringify(filters), programManager]);

  if (loading) return <Loading />;
  return <HeatmapTable title={title} cols={COLS} totalRow={totalRow} rows={rows} />;
}
